import { Component, inject, Inject, LOCALE_ID, signal, ViewChild } from '@angular/core';
import { TitleComponent } from "../shared/components/title-component/title-component";
import { SearchBarComponent } from '../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe, formatDate, NgIf, UpperCasePipe } from '@angular/common';
import { MatSpinner } from '@angular/material/progress-spinner';
import { DocumentDetailsService } from '../shared/services/document-details-service';
import { ToastrService } from '../shared/services/toastr-service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatToolbar } from "@angular/material/toolbar";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { checkBetweenDate } from '../shared/validators';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { AuthService } from '../auth/services/auth-service';

interface DetailsI {
  'assurance_id' : string,
  'police' : string,
  'vehicule' : string,
  'categorie' : string,
  'zone' : string,
  'compagnie' : string,
  'collaborateur' : string,
  'site' : string,
  'editeur' : string,
  'attestation' : string,
  'carte_rose' : string,
  'created_at' : string,
  'deleted_at' : string | null
}

@Component({
  selector: 'app-etat-documents',
  imports: [
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatSpinner,
    UpperCasePipe,
    DatePipe,
    MatToolbar,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatTabsModule,
    NgIf
],
  templateUrl: './etat-documents.html',
  styleUrl: './etat-documents.css',
})
export class EtatDocuments {

  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<DetailsI> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  searchValue = signal<string>('')
  loading = signal<boolean>(false)
  state = ''

  show = signal<boolean>(false)
  msg = signal<string>('')

  currentTabName : string = ''
  currentUser = inject(AuthService).getCurrentUser().user

  dateForm = new FormGroup({
    date_debut : new FormControl(new Date(), [Validators.required]),
    date_fin : new FormControl(new Date(), [Validators.required])
  },{validators : checkBetweenDate})

  constructor(
    private documentDetails : DocumentDetailsService,
    private toastr : ToastrService,
    private activatedRoute : ActivatedRoute,
    @Inject(LOCALE_ID) private locale : string,
  ){
      this.currentUser.profil.name
  }

  ngOnInit(): void {
    this.state = this.activatedRoute.snapshot.paramMap.get('state')!;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.currentTabName = (this.tabGroup._tabs.get(this.tabGroup.selectedIndex!)?.textLabel)!;
    this.displayedColumns = [/*'id',*/ 'police', 'vehicule', 'compagnie', 'collaborateur', 'attestation', 'carte_rose', 'bureau', 'groupe', 'editeur', 'created_at']
    this.loadDocument()
  }

  onTabChange(event : MatTabChangeEvent){
    //console.log(event.index, ' ', event.tab.textLabel);
    this.currentTabName = event.tab.textLabel
    switch (this.currentTabName) {
      case 'all':
        this.displayedColumns = [/*'id',*/ 'police', 'vehicule', 'compagnie', 'collaborateur', 'attestation', 'carte_rose', 'bureau', 'groupe', 'editeur', 'created_at']
        break;
      case 'groupe':
        this.displayedColumns = [/*'id',*/ 'groupe', 'production']
        break;
      case 'site':
        this.displayedColumns = [/*'id',*/ 'site', 'groupe', 'production']
        break;
      default:
        break;
    }
    this.loadDocument()
  }

  loadDocument(){
      this.loading.update(val => true)
      const date ={
        date_debut : formatDate(this.dateForm.get('date_debut')?.value!, "yyyy-MM-dd", this.locale),
        date_fin : formatDate(this.dateForm.get('date_fin')?.value!, "yyyy-MM-dd", this.locale),
      }

      this.documentDetails.documentDetails(this.state, date, this.currentTabName).subscribe({
      next : (res : DetailsI[]) =>{
        this.dataSource.data = res
        this.loading.update(val => false)
        if(this.state == 'servis')
          this.msg.update(val => 'Production(s)')
        else if(this.state == 'annule')
          this.msg.update(val => 'Assurances annulees')
      },
      error : (err) =>{
        this.toastr.error("une erreur est survenue")
        this.loading.update(val => false)
      }
    })
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

    if(this.state == 'servis')
      this.msg.update(val => 'Assurances servis : '+this.dataSource.filteredData.length+" / "+this.dataSource.data.length)
    else if(this.state == 'annule')
      this.msg.update(val => 'Assurances annulees : '+this.dataSource.filteredData.length+" / "+this.dataSource.data.length)
  }
}
